import {ChangeDetectionStrategy, Component, input, signal} from '@angular/core';
import {Button} from 'primeng/button';
import {Observable, take, tap} from 'rxjs';

@Component({
  selector: 'homey-submit-button',
  standalone: true,
  imports: [Button],
  templateUrl: './submit-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmitButtonComponent {
  loading = signal(false);
  label = input.required<string>();
  severity = input<'primary' | 'secondary' | 'success' | 'info' | 'warn' | 'danger' | 'help' | 'contrast'>(
    'primary'
  );
  size = input<'small' | 'normal' | 'large'>('normal');
  disabled = input(false);
  submitFunction = input.required<() => Observable<unknown> | Promise<unknown>>();

  onClick() {
    if (this.loading() || this.disabled()) {
      return;
    }

    this.loading.set(true);
    const result = this.submitFunction()();
    if (result instanceof Observable) {
      result
        .pipe(
          take(1),
          tap({error: () => this.loading.set(false), complete: () => this.loading.set(false)})
        )
        .subscribe();
    } else {
      Promise.resolve(result).finally(() => this.loading.set(false));
    }
  }
}
